import { defineStore } from "pinia";

// `emailNotificationStatus` holds a record of whether the email confirmation notification
// has been shown to a specific user (by email) on specific pages.
// Structure:
// {
//   "account": { "user1@example.com": true },
//   "account/settings": { "user2@example.com": false }
// }

export const useProfileStore = defineStore("profile", {
  state: () => ({
    profile: {},
    authUser: {
      userId: null,
      verificationToken: null,
      email: null,
    },
    loggedIn: false,
  }),
  getters: {},
  actions: {
    async fetchProfile() {
      try {
        const session = await useUserSession();
        this.profile = session.value.profile;

        this.loggedIn = session.value.loggedIn;
        //console.log("<<<<<<<<<<<<<<<<<<<<<fetchProfile called fine>>>>>>>>>>>>>>>>>>>>")
        //console.log(session.value.loggedIn)
        //console.log(session.value.profile)
      } catch (error) {
        //console.error("Failed to fetch profile:", error);
        this.profile = {};
        this.loggedIn = false;
      }
    },
    setStatewithSession(session) {
      this.profile = session.profile;
      this.loggedIn = session.loggedIn;
    },
    resetState() {
      this.profile = {};
      this.authUser = {
        userId: null,
        verificationToken: null,
        email: null,
      };
      this.loggedIn = false;
    },
    setAuthUser(userId, verificationToken, email) {
      this.authUser.userId = userId;
      this.authUser.verificationToken = verificationToken;
      this.authUser.email = email;
    },
    setProfile(profile) {
      //only updates the keys that exist in profile parameter object
      Object.assign(this.profile, profile);
    },
    shouldShowEmailNotification(pagePath) {
      const email = this.authUser.email;
      if (!email) return false;

      const emailNotificationStatus = useCookie("show_email_confirmation_notification", {
        maxAge: 60 * 60 * 24 * 365 * 10, // 10 years
        default: () => ({}),
      });
      const pageData = emailNotificationStatus.value?.[pagePath] ?? {};

      const parentPathSegment = pagePath.split("/").filter(Boolean).at(0);
      const seenInPathSegments = Object.keys(emailNotificationStatus.value || {}).some((path) => {
        return path.startsWith(`/${parentPathSegment}`) || path === `/${parentPathSegment}`;
      });

      return pageData[email] !== true && !seenInPathSegments;
    },

    markEmailNotificationSeen(pagePath) {
      const email = this.authUser.email;
      if (!email) return;

      const emailNotificationStatus = useCookie("show_email_confirmation_notification", {
        maxAge: 60 * 60 * 24 * 365 * 10, // 10 years
        default: () => ({}),
      });

      if (!emailNotificationStatus.value[pagePath]) {
        emailNotificationStatus.value[pagePath] = {};
      }

      emailNotificationStatus.value[pagePath][email] = true;
    },
  },
  persist: true,
});
